import env from '../../env';
import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

const jwtHeaders = () => ({
  jwt: localStorage.getItem('microsoftJWT'),
  Accept: 'application/json',
  'Content-Type': 'application/json',
});

export const getReport = createAsyncThunk('report/getReport', async (arg, { rejectWithValue }) => {
  const { fromDate, toDate, hasTracking = '' } = arg || {};
  const params = new URLSearchParams();
  if (hasTracking) params.append('hasTracking', hasTracking);
  const query = params.toString();

  try {
    const { data } = await axios.get(
      `${env.API_URL_PREFIX}/report/${fromDate}/${toDate}${query ? `?${query}` : ''}`,
      { headers: jwtHeaders() }
    );
    return data;
  } catch (err) {
    return rejectWithValue(err?.response?.data ?? err.message);
  }
});

export const getReportArticles = createAsyncThunk('report/getReportArticles', async (arg, { rejectWithValue }) => {
  const { fromDate, toDate, rmaStatus = 'close' } = arg || {};
  const statusFilter = rmaStatus ? `&filters[status][$eq]=${encodeURIComponent(rmaStatus)}` : '';
  const dateField = rmaStatus === 'close' || !rmaStatus ? 'closedAt' : 'createdAt';
  const url = `${env.API_URL}/rmas?${statusFilter}&filters[${dateField}][$gte]=${encodeURIComponent(
    fromDate
  )}&filters[${dateField}][$lte]=${encodeURIComponent(
    toDate
  )}&populate[debitor][fields]=classification&populate[articles][fields][0]=skuNumber&populate[articles][fields][1]=newSku&populate[articles][fields][2]=errorCode&populate[articles][fields][3]=serial&populate[articles][fields][4]=newSerial&populate[articles][fields][5]=hsn&populate[articles][fields][6]=newHsn&pagination[pageSize]=10000&sort=${dateField}:desc`;

  let res;
  try {
    const { data } = await axios.get(url, { headers: jwtHeaders() });
    res = data;
  } catch (err) {
    return rejectWithValue(err?.response?.data ?? err.message);
  }

  const rows = [];
  const items = res?.data || [];
  items.forEach((rma) => {
    const rmaId = rma?.id;
    const rmaNumber = rma?.number;
    const classification = String(
      rma?.debitor?.classification || ''
    ).toUpperCase();
    const articles = rma?.articles || [];
    articles.forEach((art) => {
      rows.push({
        rmaId,
        rmaNumber,
        skuNumber: art?.skuNumber || '',
        newSku: art?.newSku || '',
        swap: art?.newSerial || art?.newHsn ? 'yes' : 'no',
        classification,
        errorCode: art?.errorCode || '',
        newSerial: art?.newSerial || '',
      });
    });
  });

  return rows;
});
